import { Box, Stack, styled } from '@mui/material';

import { ReactComponent as ShippoLogoGreen } from '~/src/assets/logos/Shippo_logo.svg';

const OuterContainer = styled(Box)({
  backgroundColor: '#f3f7fa',
  minHeight: '100vh',
});

const InnerContainer = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  gap: theme.spacing(5),
  margin: '0 auto',
  paddingTop: '182px',
}));

const OuterBox = styled(Box)(({ theme }) => ({
  backgroundColor: 'white',
  borderRadius: '10px',
  boxShadow: '0 12px 40px rgba(0, 0, 0, 0.12)',
  padding: theme.spacing(4),
  textAlign: 'center',
  width: '410px',
}));

const InnerBox = styled(Box)({
  width: '350px',
});

export const Wrapper: React.FC = ({ children }) => (
  <OuterContainer>
    <InnerContainer>
      <ShippoLogoGreen style={{ width: '120px' }} />
      <OuterBox>
        <InnerBox>{children}</InnerBox>
      </OuterBox>
    </InnerContainer>
  </OuterContainer>
);
